module.exports = __webpack_public_path__ + "static/media/arrow.e2be9365.svg";